import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoTrioPageWidthLayout = loadable(
  () => import(/* webpackChunkName: "content/guest/header/photoTrioPageWidth" */ './PhotoTrioPageWidth'),
  'PhotoTrioPageWidthLayout',
);
